// react-redux imports
import { MouseEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import SectionTitle from "common/components/styled-components/SectionTitle";
import BooleanButton from "common/components/BooleanButton";
import BooleanButtonGroup from "common/components/styled-components/BooleanButtonGroup";

// styled-components imports
import BooleanButtonContainer from "../styled-components/BooleanButtonContainer";
import UserInputSection from "../styled-components/UserInputSection";

import { setUsesEcologicalProducts } from "./nutritionSlice";

function StepTwo() {
  const dispatch = useDispatch();
  const usesEcologicalProducts = useSelector(
    (state: RootState) => state.calculator.nutrition.usesEcologicalProducts
  );

  function handleSelection(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    dispatch(setUsesEcologicalProducts(Boolean(Number(e.currentTarget.value))));
  }

  return (
    <>
      <SectionTitle>¿Consumes productos ecológicos?</SectionTitle>
      <UserInputSection>
        <BooleanButtonGroup>
          <BooleanButtonContainer>
            <BooleanButton
              value={true}
              label="Sí"
              selected={usesEcologicalProducts}
              onClick={handleSelection}
            />
          </BooleanButtonContainer>
          <BooleanButtonContainer>
            <BooleanButton
              value={false}
              label="No"
              selected={!usesEcologicalProducts}
              onClick={handleSelection}
            />
          </BooleanButtonContainer>
        </BooleanButtonGroup>
      </UserInputSection>
    </>
  );
}

export default StepTwo;
